export const typographyText = (text) => {
  let result = text.replace(/-/g, '\u2011');

  result = result.replace(/(^|[\s.,;:!?])(([A-Za-zА-Яа-яЁё]{1,2}|\d+))\s/g, '$1$2\u00A0');

  const triggerWords = [
    'для',
    'при',
    'про',
    'над',
    'под',
    'вне',
    'без',
    'for',
    'the',
    'auf',
    'aus',
    'bei',
    'bis',
    'ins',
    'mit',
    'von',
    'vor',
    'zum',
    'zur',
  ];

  const pattern = new RegExp(`(^|[^A-Za-zА-Яа-яЁё])((?:${triggerWords.join('|')}))\\s`, 'giu');
  result = result.replace(pattern, '$1$2\u00A0');

  return result;
};
